<template>
  <div class="row member-card">
    <div class="memberSearch-wrap">
      <form @submit.prevent="setFilters">
        <div class="form-group row">
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Member First Name</label>
            <input
              v-model="filters.first_name"
              type="text"
              class="memberSearch-field"
              placeholder="Enter Member Name"
            />
          </div>
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Member Last Name</label>
            <input
              v-model="filters.last_name"
              type="text"
              class="memberSearch-field"
              placeholder="Enter Member Name"
            />
          </div>
          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Member Email</label>
            <input
              v-model="filters.member_email"
              type="email"
              class="memberSearch-field"
              placeholder="Enter Member Email"
            />
          </div>

          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4 plan-name-auto">
            <label>Plan Name</label>
            <a-auto-complete
              v-model="filters.plan_name"
              :data-source="planNames"
              placeholder="Enter Plan Name"
              @search="onNameSearch"
              @change="onChange"
            />
          </div>
          <div class="form-group row">
            <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
              <label>Created Date</label>
              <div class="effective_date">
                <date-picker
                  input-class="memberSearch-field"
                  placeholder="Enter Created Date"
                  type="date"
                  v-model="filters.created_date"
                  value-type="format"
                ></date-picker>
              </div>
            </div>
            <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
              <label>Submitted Date</label>
              <div class="effective_date">
                <date-picker
                  input-class="memberSearch-field"
                  placeholder="Enter Submitted Date"
                  type="date"
                  v-model="filters.submitted_date"
                  value-type="format"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-end">
          <div class="col-xxl-2 col-xl-3 claim-btn-container">
            <button type="submit" class="univ-btn">Search</button>
            <!-- <button class="clear-search univ-btn" @click="clearData">
              Clear Search
            </button> -->
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
// import Helper from "@/resource/Helper";
import Api from "@/resource/Api";

export default {
  name: "ClientSearch",

  props: {
    filters: {
      required: true,
    },
    clear: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      planNames: [],
    };
  },

  methods: {
    onNameSearch(searchText) {
      if (searchText && searchText.length > 3) {
        this.planNames = [];
        this.fetchPlanNames(searchText);
      }
    },
    onChange(value) {
      if (value == "") {
        this.planNames = [];
        this.clearSearch();
      }
    },
    async fetchPlanNames(searchText) {
      this.planNames = [];
      const url = `v2/get-prudential-plan?plan_name=${searchText}`;
      try {
        const {
          data: { data },
        } = await Api.get(url);
        this.planNames = [...new Set(data.map((item) => item.plan_name))];
      } catch (error) {
        this.planNames = [];
      }
    },

    setFilters() {
      this.$emit("onSearch", this.filters);
    },
    clearSearch() {
      this.$emit("onClearSearch");
    },
  },

  watch: {
    clear: function () {
      this.selectedPlans = [];
      this.selectedCarriers = [];
    },
  },
};
</script>
<style scoped>
.effective_date .mx-datepicker {
  width: 100% !important;
}

.form-select:focus {
  border-color: #03c3ec;
}
</style>
<style>
.btn-export-btn {
  background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
  transition: all 0.6s ease;
  font-size: 13px;
}
.btn-export-btn:hover {
  color: #fff;
  transition: all 0.6s ease;
  box-shadow: 0 8px 20px -13px rgb(0 0 0 / 69%);
}
.btn-export-btn::before {
  content: "\f56e";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  margin-right: 5px;
}
.export-dropdown .dropdown-menu {
  font-size: 15px;
}
.export-dropdown {
  box-shadow: none !important;
}
.claim-btn-container {
  display: flex;
  gap: 20px;
  width: 20%;
}
.plan-name-auto .ant-select-auto-complete.ant-select .ant-input{
  padding: 19px;
}
.plan-name-auto .ant-select-auto-complete.ant-select .ant-input::placeholder {
  color: #757070;
}
 .mx-datepicker-popup {
    z-index: 1 ;
}
</style>
